// // /pages/FleetManagement/Drivers/components/DriverForm.tsx
// import React, { useState, useEffect } from 'react';
// import { useForm, SubmitHandler } from 'react-hook-form';
// import {
//     Box,
//     Button,
//     FormControl,
//     FormErrorMessage,
//     FormLabel,
//     Input,
//     VStack,
//     HStack,
//     Text,
//     Grid,
//     CheckboxGroup,
//     Checkbox,
//     Stack,
//     Spinner,
//     useColorModeValue,
//     FormHelperText,
//     Heading,
// } from '@chakra-ui/react';
// import { apiClient } from '@/lib/api/client';
// import { useToastNotification } from '@/lib/utils/useToastNotification';

// interface DriverFormInputs {
//     first_name: string;
//     last_name: string;
//     contact_number: string;
//     assigned_truck_plate_numbers: string[];
//     is_active: number;
// }

// export function DriverForm({ driverId, initialData, onSuccess, onCancel }: any) {
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [trucks, setTrucks] = useState<{ id: number, plate_number: string }[]>([]);
//     const [loadingTrucks, setLoadingTrucks] = useState(true);
//     const { showError, showSuccess } = useToastNotification();
//     const borderColor = useColorModeValue('gray.200', 'gray.600');

//     const isEditMode = !!driverId;

//     const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<DriverFormInputs>({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             contact_number: '',
//             assigned_truck_plate_numbers: [],
//             is_active: 1,
//         },
//     });

//     const selectedPlates = watch('assigned_truck_plate_numbers');

//     useEffect(() => {
//         apiClient.get('/trucks/truck-list')
//             .then(res => setTrucks(res.data.data || res.data))
//             .finally(() => setLoadingTrucks(false));
//     }, []);

//     useEffect(() => {
//         if (initialData) reset(initialData);
//     }, [initialData, reset]);

//     const onSubmit: SubmitHandler<DriverFormInputs> = async (data) => {
//         setIsSubmitting(true);
//         try {
//             const endpoint = isEditMode ? `/drivers/${driverId}` : '/drivers';
//             await (isEditMode ? apiClient.put(endpoint, data) : apiClient.post(endpoint, data));
//             showSuccess('Success', `Driver ${isEditMode ? 'updated' : 'created'} successfully.`);
//             onSuccess?.();
//         } catch (error: any) {
//             showError(error);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <Box as="form" onSubmit={handleSubmit(onSubmit)} maxW="700px">
//             <VStack spacing={6} align="stretch">
//                 <Box>
//                     <Heading size="md" mb={1}>
//                         {isEditMode ? 'Edit Driver' : 'Add New Driver'}
//                     </Heading>
//                     <Text fontSize="sm" color="gray.600">
//                         {isEditMode 
//                             ? 'Update driver details and truck assignments.' 
//                             : 'Register a new driver and assign them to trucks.'}
//                     </Text>
//                 </Box>

//                 <VStack spacing={4} align="stretch">
//                     {/* First Name */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">
//                             First Name <Text as="span" color="red.500">*</Text>
//                         </FormLabel>
//                         <FormControl isInvalid={!!errors.first_name}>
//                             <Input 
//                                 {...register('first_name', { required: 'First name is required' })} 
//                                 placeholder="Enter first name" 
//                                 onInput={(e) => {
//                                     // Allows only letters (uppercase/lowercase) and spaces
//                                     e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '');
//                                 }}
//                             />
//                             <FormErrorMessage>{errors.first_name?.message}</FormErrorMessage>
//                         </FormControl>
//                     </Grid>

//                     {/* Last Name */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">
//                             Last Name <Text as="span" color="red.500">*</Text>
//                         </FormLabel>
//                         <FormControl isInvalid={!!errors.last_name}>
//                             <Input 
//                                 {...register('last_name', { required: 'Last name is required' })} 
//                                 placeholder="Enter last name" 
//                                 onInput={(e) => {
//                                     // Allows only letters (uppercase/lowercase) and spaces
//                                     e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '');
//                                 }}
//                             />
//                             <FormErrorMessage>{errors.last_name?.message}</FormErrorMessage>
//                         </FormControl>
//                     </Grid>

//                     {/* Contact Number with New Validation */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">
//                             Contact No. <Text as="span" color="red.500">*</Text>
//                         </FormLabel>
//                         <FormControl isInvalid={!!errors.contact_number}>
//                             <Input 
//                                 {...register('contact_number', { 
//                                     required: 'Contact number is required',
//                                     pattern: {
//                                         // Accepts 09XX... (11 digits), +639XX... (13 chars), or +632XX... (12 chars)
//                                         value: /^(09\d{9}|\+639\d{9}|\+632\d{8})$/,
//                                         message: 'Invalid PH mobile (09...) or Manila landline (+632...)'
//                                     }
//                                 })} 
//                                 placeholder="09XXXXXXXXX or +632XXXXXXXX" 
//                             />
//                             <FormErrorMessage>{errors.contact_number?.message}</FormErrorMessage>
//                         </FormControl>
//                     </Grid>

//                     {/* Assign Trucks */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
//                         <FormLabel pt={2} fontWeight="medium">Assign Trucks</FormLabel>
//                         <FormControl>
//                             <Box 
//                                 p={4} 
//                                 border="1px solid" 
//                                 borderColor={borderColor} 
//                                 borderRadius="md" 
//                                 bg="gray.50" 
//                                 maxH="200px" 
//                                 overflowY="auto"
//                             >
//                                 {loadingTrucks ? <Spinner size="xs" /> : (
//                                     <CheckboxGroup value={selectedPlates} onChange={(v) => setValue('assigned_truck_plate_numbers', v as string[])}>
//                                         <Stack spacing={[1, 4]} direction={['column', 'row']} wrap="wrap">
//                                             {trucks.map((t) => (
//                                                 <Checkbox key={t.id} value={t.plate_number} colorScheme="blue">
//                                                     <Text fontSize="sm">{t.plate_number}</Text>
//                                                 </Checkbox>
//                                             ))}
//                                         </Stack>
//                                     </CheckboxGroup>
//                                 )}
//                             </Box>
//                             <FormHelperText fontSize="xs">Select one or more trucks for this driver.</FormHelperText>
//                         </FormControl>
//                     </Grid>
//                 </VStack>

//                 <HStack spacing={4} justify="flex-end" pt={4}>
//                     <Button variant="outline" onClick={onCancel} isDisabled={isSubmitting}>Cancel</Button>
//                     <Button type="submit" colorScheme="blue" isLoading={isSubmitting} px={8}>
//                         {isEditMode ? 'Save' : 'Create Driver'}
//                     </Button>
//                 </HStack>
//             </VStack>
//         </Box>
//     );
// }

// import React, { useState, useEffect, useRef } from 'react';
// import { useForm, SubmitHandler } from 'react-hook-form';
// import {
//     Box,
//     Button,
//     FormControl,
//     FormErrorMessage,
//     FormLabel,
//     Input,
//     VStack,
//     HStack,
//     Text,
//     Grid,
//     Spinner,
//     useColorModeValue,
//     FormHelperText,
//     Heading,
//     Tag,
//     TagLabel,
//     TagCloseButton,
//     Wrap,
//     WrapItem,
//     List,
//     ListItem,
//     InputGroup,
//     InputRightElement,
// } from '@chakra-ui/react';
// import { apiClient } from '@/lib/api/client';
// import { useToastNotification } from '@/lib/utils/useToastNotification';

// interface DriverFormInputs {
//     first_name: string;
//     last_name: string;
//     contact_number: string;
//     assigned_truck_plate_numbers: string[];
//     is_active: number;
// }

// export function DriverForm({ driverId, initialData, onSuccess, onCancel }: any) {
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [trucks, setTrucks] = useState<{ id: number, plate_number: string }[]>([]);
//     const [loadingTrucks, setLoadingTrucks] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [showResults, setShowResults] = useState(false);
//     const { showError, showSuccess } = useToastNotification();
    
//     const borderColor = useColorModeValue('gray.200', 'gray.600');
//     const listBg = useColorModeValue('white', 'gray.700');
//     const isEditMode = !!driverId;

//     const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<DriverFormInputs>({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             contact_number: '',
//             assigned_truck_plate_numbers: [],
//             is_active: 1,
//         },
//     });

//     const searchContainerRef = useRef<HTMLDivElement>(null);

//     useEffect(() => {
//         const handleClickOutside = (event: MouseEvent) => {
//             if (
//                 searchContainerRef.current && 
//                 !searchContainerRef.current.contains(event.target as Node)
//             ) {
//                 setShowResults(false);
//             }
//         };

//         // Attach listener
//         document.addEventListener('mousedown', handleClickOutside);
        
//         // Clean up listener on unmount
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const selectedPlates = watch('assigned_truck_plate_numbers') || [];

//     useEffect(() => {
//         apiClient.get('/trucks/active-list')
//             .then(res => setTrucks(res.data.data || res.data))
//             .finally(() => setLoadingTrucks(false));
//     }, []);

//     useEffect(() => {
//         if (initialData) reset(initialData);
//     }, [initialData, reset]);

//     // Filter trucks based on search term and exclude already selected ones
//     const filteredTrucks = trucks.filter(truck => 
//         truck.plate_number.toLowerCase().includes(searchTerm.toLowerCase()) &&
//         !selectedPlates.includes(truck.plate_number)
//     );

//     const handleAddPlate = (plate: string) => {
//         setValue('assigned_truck_plate_numbers', [...selectedPlates, plate]);
//         setSearchTerm('');
//         setShowResults(false);
//     };

//     const handleRemovePlate = (plateToRemove: string) => {
//         setValue('assigned_truck_plate_numbers', selectedPlates.filter(p => p !== plateToRemove));
//     };

//     const onSubmit: SubmitHandler<DriverFormInputs> = async (data) => {
//         setIsSubmitting(true);
//         try {
//             const endpoint = isEditMode ? `/drivers/${driverId}` : '/drivers';
//             await (isEditMode ? apiClient.put(endpoint, data) : apiClient.post(endpoint, data));
//             showSuccess('Success', `Driver ${isEditMode ? 'updated' : 'created'} successfully.`);
//             onSuccess?.();
//         } catch (error: any) {
//             showError(error);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <Box as="form" onSubmit={handleSubmit(onSubmit)} maxW="700px">
//             <VStack spacing={6} align="stretch">
//                 <Box>
//                     <Heading size="md" mb={1}>{isEditMode ? 'Edit Driver' : 'Add New Driver'}</Heading>
//                     <Text fontSize="sm" color="gray.600">
//                         {isEditMode ? 'Update driver details.' : 'Register a new driver.'}
//                     </Text>
//                 </Box>

//                 <VStack spacing={4} align="stretch">
//                     {/* First Name & Last Name (Keep your existing letter-only logic here) */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">First Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.first_name}>
//                             <Input {...register('first_name', { required: 'Required' })} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} />
//                         </FormControl>
//                     </Grid>

//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Last Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.last_name}>
//                             <Input {...register('last_name', { required: 'Required' })} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} />
//                         </FormControl>
//                     </Grid>

//                     {/* Contact Number (Keep existing logic) */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Contact No. <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.contact_number}>
//                             <Input {...register('contact_number', { required: 'Required' })} />
//                         </FormControl>
//                     </Grid>

//                     {/* Searchable Assign Trucks */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
//                         <FormLabel pt={2} fontWeight="medium">Assign Trucks</FormLabel>
//                         <FormControl>
//                             <VStack align="stretch" spacing={3}>
//                                 {/* Tag Display Area */}
//                                 <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="white">
//                                     {selectedPlates.map((plate) => (
//                                         <WrapItem key={plate}>
//                                             <Tag size="md" variant="solid" colorScheme="blue" borderRadius="full">
//                                                 <TagLabel>{plate}</TagLabel>
//                                                 <TagCloseButton onClick={() => handleRemovePlate(plate)} />
//                                             </Tag>
//                                         </WrapItem>
//                                     ))}
//                                 </Wrap>

//                                 {/* 3. Wrap the Input and List in the Ref container */}
//                                 <Box position="relative" ref={searchContainerRef}>
//                                     <InputGroup size="sm">
//                                         <Input 
//                                             placeholder="Type truck plate number..." 
//                                             value={searchTerm}
//                                             onChange={(e) => {
//                                                 setSearchTerm(e.target.value);
//                                                 setShowResults(true);
//                                             }}
//                                             onFocus={() => setShowResults(true)}
//                                         />
//                                         <InputRightElement>
//                                             {loadingTrucks && <Spinner size="xs" />}
//                                         </InputRightElement>
//                                     </InputGroup>

//                                     {showResults && searchTerm && (
//                                         <List 
//                                             position="absolute" 
//                                             top="100%" 
//                                             left={0} 
//                                             right={0} 
//                                             bg={listBg} 
//                                             boxShadow="lg" 
//                                             borderRadius="md" 
//                                             zIndex={10} 
//                                             maxH="150px" 
//                                             overflowY="auto"
//                                             border="1px solid"
//                                             borderColor={borderColor}
//                                             mt={1}
//                                         >
//                                             {filteredTrucks.map((truck) => (
//                                                 <ListItem 
//                                                     key={truck.id} 
//                                                     px={3} 
//                                                     py={2} 
//                                                     _hover={{ bg: 'blue.50', color: 'blue.600', cursor: 'pointer' }}
//                                                     onClick={() => handleAddPlate(truck.plate_number)}
//                                                 >
//                                                     <Text fontSize="sm">{truck.plate_number}</Text>
//                                                 </ListItem>
//                                             ))}
//                                             {filteredTrucks.length === 0 && (
//                                                 <ListItem px={3} py={2} fontSize="sm" color="gray.500">No results</ListItem>
//                                             )}
//                                         </List>
//                                     )}
//                                 </Box>
//                             </VStack>
//                         </FormControl>
//                     </Grid>
//                 </VStack>

//                 <HStack spacing={4} justify="flex-end" pt={4}>
//                     <Button variant="outline" onClick={onCancel} isDisabled={isSubmitting}>Cancel</Button>
//                     <Button type="submit" colorScheme="blue" isLoading={isSubmitting} px={8}>
//                         {isEditMode ? 'Save' : 'Create Driver'}
//                     </Button>
//                 </HStack>
//             </VStack>
//         </Box>
//     );
//}

// import React, { useState, useEffect, useRef } from 'react';
// import { useForm, SubmitHandler } from 'react-hook-form';
// import {
//     Box, Button, FormControl, FormErrorMessage, FormLabel, Input, VStack, HStack,
//     Text, Grid, Spinner, useColorModeValue, FormHelperText, Heading,
//     Tag, TagLabel, TagCloseButton, Wrap, WrapItem, List, ListItem,
//     InputGroup, InputRightElement,
// } from '@chakra-ui/react';
// import { apiClient } from '@/lib/api/client';
// import { useToastNotification } from '@/lib/utils/useToastNotification';

// interface DriverFormInputs {
//     first_name: string;
//     last_name: string;
//     contact_number: string;
//     assigned_truck_plate_numbers: string[];
//     helper_id: number; // Store IDs as requested
//     is_active: number;
// }

// export function DriverForm({ driverId, initialData, onSuccess, onCancel }: any) {
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [trucks, setTrucks] = useState<{ id: number, plate_number: string }[]>([]);
//     const [helpers, setHelpers] = useState<{ id: number, first_name: string, last_name: string }[]>([]);
//     const [loadingData, setLoadingData] = useState(true);
    
//     // Search states for Trucks
//     const [truckSearch, setTruckSearch] = useState('');
//     const [showTruckResults, setShowTruckResults] = useState(false);
    
//     // Search states for Helpers
//     const [helperSearch, setHelperSearch] = useState('');
//     const [showHelperResults, setShowHelperResults] = useState(false);

//     const { showError, showSuccess } = useToastNotification();
//     const borderColor = useColorModeValue('gray.200', 'gray.600');
//     const listBg = useColorModeValue('white', 'gray.700');
//     const isEditMode = !!driverId;

//     const truckRef = useRef<HTMLDivElement>(null);
//     const helperRef = useRef<HTMLDivElement>(null);

//     const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<DriverFormInputs>({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             contact_number: '',
//             assigned_truck_plate_numbers: [],
//             helper_id: 0,
//             is_active: 1,
//         },
//     });

//     const selectedPlates = watch('assigned_truck_plate_numbers') || [];
//     const selectedHelperIds = watch('helper_id') || [];

//     // Initialize data
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const [truckRes, helperRes] = await Promise.all([
//                     apiClient.get('/trucks/active-list'),
//                     apiClient.get('/helpers/active-list')
//                 ]);
//                 setTrucks(truckRes.data.data || truckRes.data);
//                 setHelpers(helperRes.data.data || helperRes.data);
//             } catch (err) {
//                 showError(err);
//             } finally {
//                 setLoadingData(false);
//             }
//         };
//         fetchData();
//     }, [showError]);

//     // Handle Outside Clicks
//     useEffect(() => {
//         const handleClickOutside = (event: MouseEvent) => {
//             if (truckRef.current && !truckRef.current.contains(event.target as Node)) setShowTruckResults(false);
//             if (helperRef.current && !helperRef.current.contains(event.target as Node)) setShowHelperResults(false);
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     useEffect(() => {
//         if (initialData) reset(initialData);
//     }, [initialData, reset]);

//     // --- Truck Logic ---
//     const filteredTrucks = trucks.filter(t => 
//         t.plate_number.toLowerCase().includes(truckSearch.toLowerCase()) && !selectedPlates.includes(t.plate_number)
//     );

//     // --- Helper Logic ---
//     // Search both first and last name
//     const filteredHelpers = helpers.filter(h => {
//         const fullName = `${h.first_name} ${h.last_name}`.toLowerCase();
//         return fullName.includes(helperSearch.toLowerCase()) && !selectedHelperIds.includes(h.id);
//     });

//     const handleAddHelper = (id: number) => {
//         setValue('helper_id', [...selectedHelperIds, id]);
//         setHelperSearch('');
//         setShowHelperResults(false);
//     };

//     const handleRemoveHelper = (idToRemove: number) => {
//         setValue('helper_id', selectedHelperIds.filter(id => id !== idToRemove));
//     };

//     // Helper to find name for the Tag display
//     const getHelperName = (id: number) => {
//         const helper = helpers.find(h => h.id === id);
//         return helper ? `${helper.first_name} ${helper.last_name}` : 'Unknown Helper';
//     };

//     const onSubmit: SubmitHandler<DriverFormInputs> = async (data) => {
//         setIsSubmitting(true);
//         try {
//             const endpoint = isEditMode ? `/drivers/${driverId}` : '/drivers';
//             await (isEditMode ? apiClient.put(endpoint, data) : apiClient.post(endpoint, data));
//             showSuccess('Success', `Driver ${isEditMode ? 'updated' : 'created'} successfully.`);
//             onSuccess?.();
//         } catch (error: any) {
//             showError(error);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <Box as="form" onSubmit={handleSubmit(onSubmit)} maxW="700px">
//             <VStack spacing={6} align="stretch">
//                 {/* ... Names and Contact fields stay the same ... */}
//                 <VStack spacing={4} align="stretch">
//                     {/* First Name */}
//                     {/* <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">First Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.first_name}>
//                             <Input {...register('first_name', { required: 'Required' })} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} />
//                         </FormControl>
//                     </Grid> */}

//                     {/* Last Name */}
//                     {/* <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Last Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.last_name}>
//                             <Input {...register('last_name', { required: 'Required' })} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} />
//                         </FormControl>
//                     </Grid> */}

//                     {/* Contact No */}
//                     {/* <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Contact No. <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.contact_number}>
//                             <Input {...register('contact_number', { required: 'Required' })} />
//                         </FormControl>
//                     </Grid> */}
//                     {/* First Name */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">First Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.first_name}>
//                             <Input 
//                                 {...register('first_name', { required: 'Required' })} 
//                                 onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} 
//                             />
//                             <FormErrorMessage>{errors.first_name?.message}</FormErrorMessage>
//                         </FormControl>
//                     </Grid>

//                     {/* Last Name */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Last Name <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.last_name}>
//                             <Input 
//                                 {...register('last_name', { required: 'Required' })} 
//                                 onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} 
//                             />
//                             <FormErrorMessage>{errors.last_name?.message}</FormErrorMessage>
//                         </FormControl>
//                     </Grid>

//                     {/* Contact No - FLEXIBLE PREFIX, STRICT DIGIT COUNT */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
//                         <FormLabel mb={0} fontWeight="medium">Contact No. <Text as="span" color="red.500">*</Text></FormLabel>
//                         <FormControl isInvalid={!!errors.contact_number}>
//                             <Input 
//                                 {...register('contact_number', { 
//                                     required: 'Contact number is required',
//                                     validate: (value) => {
//                                         // Pattern 1: Starts with 0 and followed by exactly 10 digits (Total 11)
//                                         const startsWithZero = /^0\d{10}$/.test(value);
//                                         // Pattern 2: Starts with +63 and followed by exactly 10 digits (Total 12 characters)
//                                         const startsWithPH = /^\+63\d{10}$/.test(value);
                                        
//                                         return startsWithZero || startsWithPH || 'Must be 11 digits (starting with 0) or 12 characters (starting with +63)';
//                                     }
//                                 })} 
//                                 placeholder="0XXXXXXXXXX or +63XXXXXXXXXX"
//                                 onInput={(e) => {
//                                     // Keep only numbers and the plus sign
//                                     e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '');
//                                 }}
//                             />
//                             <FormErrorMessage>
//                                 {errors.contact_number?.message}
//                             </FormErrorMessage>
//                             <FormHelperText fontSize="xs">
//                                 Enter an 11-digit number starting with 0, or 12 characters starting with +63.
//                             </FormHelperText>
//                         </FormControl>
//                     </Grid>

//                     {/* Assign Trucks (Existing Logic) */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
//                         <FormLabel pt={2} fontWeight="medium">Assign Trucks</FormLabel>
//                         <FormControl>
//                             <VStack align="stretch" spacing={2}>
//                                 <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="gray.50">
//                                     {selectedPlates.map((plate) => (
//                                         <WrapItem key={plate}>
//                                             <Tag size="md" variant="solid" colorScheme="blue" borderRadius="full">
//                                                 <TagLabel>{plate}</TagLabel>
//                                                 <TagCloseButton onClick={() => setValue('assigned_truck_plate_numbers', selectedPlates.filter(p => p !== plate))} />
//                                             </Tag>
//                                         </WrapItem>
//                                     ))}
//                                 </Wrap>
//                                 <Box position="relative" ref={truckRef}>
//                                     <InputGroup size="sm">
//                                         <Input placeholder="Search truck plate..." value={truckSearch} onChange={(e) => {setTruckSearch(e.target.value); setShowTruckResults(true)}} onFocus={() => setShowTruckResults(true)} />
//                                         <InputRightElement>{loadingData && <Spinner size="xs" />}</InputRightElement>
//                                     </InputGroup>
//                                     {showTruckResults && truckSearch && (
//                                         <List position="absolute" top="100%" left={0} right={0} bg={listBg} boxShadow="lg" borderRadius="md" zIndex={11} maxH="150px" overflowY="auto" border="1px solid" borderColor={borderColor} mt={1}>
//                                             {filteredTrucks.map(t => (
//                                                 <ListItem key={t.id} px={3} py={2} _hover={{ bg: 'blue.50', cursor: 'pointer' }} onClick={() => { setValue('assigned_truck_plate_numbers', [...selectedPlates, t.plate_number]); setTruckSearch(''); setShowTruckResults(false); }}>
//                                                     {t.plate_number}
//                                                 </ListItem>
//                                             ))}
//                                         </List>
//                                     )}
//                                 </Box>
//                             </VStack>
//                         </FormControl>
//                     </Grid>

//                     {/* NEW: Assign Helpers Logic */}
//                     <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
//                         <FormLabel pt={2} fontWeight="medium">Assign Helpers</FormLabel>
//                         <FormControl>
//                             <VStack align="stretch" spacing={2}>
//                                 {/* Tag Display Area */}
//                                 <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="gray.50">
//                                     {selectedHelperIds.map((id) => (
//                                         <WrapItem key={id}>
//                                             <Tag size="md" variant="solid" colorScheme="green" borderRadius="full">
//                                                 <TagLabel>{getHelperName(id)}</TagLabel>
//                                                 <TagCloseButton onClick={() => handleRemoveHelper(id)} />
//                                             </Tag>
//                                         </WrapItem>
//                                     ))}
//                                     {selectedHelperIds.length === 0 && <Text fontSize="xs" color="gray.400" p={1}>No helpers assigned</Text>}
//                                 </Wrap>

//                                 {/* Search Input Area */}
//                                 <Box position="relative" ref={helperRef}>
//                                     <InputGroup size="sm">
//                                         <Input 
//                                             placeholder="Search helper name..." 
//                                             value={helperSearch}
//                                             onChange={(e) => {
//                                                 setHelperSearch(e.target.value);
//                                                 setShowHelperResults(true);
//                                             }}
//                                             onFocus={() => setShowHelperResults(true)}
//                                         />
//                                         <InputRightElement>
//                                             {loadingData && <Spinner size="xs" />}
//                                         </InputRightElement>
//                                     </InputGroup>

//                                     {/* Dropdown Results */}
//                                     {showHelperResults && helperSearch && (
//                                         <List 
//                                             position="absolute" top="100%" left={0} right={0} 
//                                             bg={listBg} boxShadow="lg" borderRadius="md" 
//                                             zIndex={10} maxH="150px" overflowY="auto" 
//                                             border="1px solid" borderColor={borderColor} mt={1}
//                                         >
//                                             {filteredHelpers.map((helper) => (
//                                                 <ListItem 
//                                                     key={helper.id} px={3} py={2} 
//                                                     _hover={{ bg: 'green.50', color: 'green.700', cursor: 'pointer' }}
//                                                     onClick={() => handleAddHelper(helper.id)}
//                                                 >
//                                                     <Text fontSize="sm">{helper.first_name} {helper.last_name}</Text>
//                                                 </ListItem>
//                                             ))}
//                                             {filteredHelpers.length === 0 && (
//                                                 <ListItem px={3} py={2} fontSize="sm" color="gray.500">No helpers found</ListItem>
//                                             )}
//                                         </List>
//                                     )}
//                                 </Box>
//                                 <FormHelperText fontSize="xs">Assign one or more helpers to this driver.</FormHelperText>
//                             </VStack>
//                         </FormControl>
//                     </Grid>
//                 </VStack>

//                 <HStack spacing={4} justify="flex-end" pt={4}>
//                     <Button variant="outline" onClick={onCancel} isDisabled={isSubmitting}>Cancel</Button>
//                     <Button type="submit" colorScheme="blue" isLoading={isSubmitting} px={8}>
//                         {isEditMode ? 'Save' : 'Create Driver'}
//                     </Button>
//                 </HStack>
//             </VStack>
//         </Box>
//     );
    
// }

import React, { useState, useEffect, useRef } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import {
    Box, Button, FormControl, FormErrorMessage, FormLabel, Input, VStack, HStack,
    Text, Grid, Spinner, useColorModeValue, FormHelperText,
    Tag, TagLabel, TagCloseButton, Wrap, WrapItem, List, ListItem,
    InputGroup, InputRightElement,
} from '@chakra-ui/react';
import { apiClient } from '@/lib/api/client';
import { useToastNotification } from '@/lib/utils/useToastNotification';

interface DriverFormInputs {
    first_name: string;
    last_name: string;
    contact_number: string;
    assigned_truck_plate_numbers: string[];
    helper_id: number | null; // Updated: Single integer ID
    is_active: number;
}

export function DriverForm({ driverId, initialData, onSuccess, onCancel }: any) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [trucks, setTrucks] = useState<{ id: number, plate_number: string }[]>([]);
    const [helpers, setHelpers] = useState<{ id: number, first_name: string, last_name: string }[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    
    const [truckSearch, setTruckSearch] = useState('');
    const [showTruckResults, setShowTruckResults] = useState(false);
    
    const [helperSearch, setHelperSearch] = useState('');
    const [showHelperResults, setShowHelperResults] = useState(false);

    const { showError, showSuccess } = useToastNotification();
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const listBg = useColorModeValue('white', 'gray.700');
    const isEditMode = !!driverId;

    const truckRef = useRef<HTMLDivElement>(null);
    const helperRef = useRef<HTMLDivElement>(null);

    const { register, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<DriverFormInputs>({
        defaultValues: {
            first_name: '',
            last_name: '',
            contact_number: '',
            assigned_truck_plate_numbers: [],
            helper_id: null,
            is_active: 1,
        },
    });

    const selectedPlates = watch('assigned_truck_plate_numbers') || [];
    const selectedHelperId = watch('helper_id'); // Updated: singular value

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [truckRes, helperRes] = await Promise.all([
                    apiClient.get('/trucks/active-list'),
                    apiClient.get('/helpers/active-list')
                ]);
                setTrucks(truckRes.data.data || truckRes.data);
                setHelpers(helperRes.data.data || helperRes.data);
            } catch (err) {
                showError(err);
            } finally {
                setLoadingData(false);
            }
        };
        fetchData();
    }, [showError]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (truckRef.current && !truckRef.current.contains(event.target as Node)) setShowTruckResults(false);
            if (helperRef.current && !helperRef.current.contains(event.target as Node)) setShowHelperResults(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (initialData) reset(initialData);
    }, [initialData, reset]);

    const filteredTrucks = trucks.filter(t => 
        t.plate_number.toLowerCase().includes(truckSearch.toLowerCase()) && !selectedPlates.includes(t.plate_number)
    );

    const filteredHelpers = helpers.filter(h => {
        const fullName = `${h.first_name} ${h.last_name}`.toLowerCase();
        // Updated: Only filter by search, selection logic handled by single assignment
        return fullName.includes(helperSearch.toLowerCase()) && h.id !== selectedHelperId;
    });

    const handleAddHelper = (id: number) => {
        setValue('helper_id', id); // Updated: Direct assignment instead of array
        setHelperSearch('');
        setShowHelperResults(false);
    };

    const handleRemoveHelper = () => {
        setValue('helper_id', null); // Updated: Reset to 0
    };

    const getHelperName = (id: number) => {
        const helper = helpers.find(h => h.id === id);
        return helper ? `${helper.first_name} ${helper.last_name}` : '';
    };

    // const onSubmit: SubmitHandler<DriverFormInputs> = async (data) => {
    //     setIsSubmitting(true);
    //     try {
    //         const endpoint = isEditMode ? `/drivers/${driverId}` : '/drivers';
    //         await (isEditMode ? apiClient.put(endpoint, data) : apiClient.post(endpoint, data));
    //         showSuccess('Success', `Driver ${isEditMode ? 'updated' : 'created'} successfully.`);
    //         onSuccess?.();
    //     } catch (error: any) {
    //         showError(error);
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };
    const onSubmit: SubmitHandler<DriverFormInputs> = async (data) => {
        setIsSubmitting(true);
        try {
            // 4. Ensure helper_id is null if not selected before sending to API
            const payload = {
                ...data,
                helper_id: data.helper_id === 0 ? null : data.helper_id
            };

            const endpoint = isEditMode ? `/drivers/${driverId}` : '/drivers';
            await (isEditMode ? apiClient.put(endpoint, payload) : apiClient.post(endpoint, payload));
            
            showSuccess('Success', `Driver ${isEditMode ? 'updated' : 'created'} successfully.`);
            onSuccess?.();
        } catch (error: any) {
            showError(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box as="form" onSubmit={handleSubmit(onSubmit)} maxW="700px">
            <VStack spacing={6} align="stretch">
                <VStack spacing={4} align="stretch">
                    {/* First Name */}
                    <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
                        <FormLabel mb={0} fontWeight="medium">First Name <Text as="span" color="red.500">*</Text></FormLabel>
                        <FormControl isInvalid={!!errors.first_name}>
                            <Input 
                                {...register('first_name', { required: 'Required' })} 
                                onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} 
                            />
                            <FormErrorMessage>{errors.first_name?.message}</FormErrorMessage>
                        </FormControl>
                    </Grid>

                    {/* Last Name */}
                    <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
                        <FormLabel mb={0} fontWeight="medium">Last Name <Text as="span" color="red.500">*</Text></FormLabel>
                        <FormControl isInvalid={!!errors.last_name}>
                            <Input 
                                {...register('last_name', { required: 'Required' })} 
                                onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^a-zA-Z\s]/g, '')} 
                            />
                            <FormErrorMessage>{errors.last_name?.message}</FormErrorMessage>
                        </FormControl>
                    </Grid>

                    {/* Contact Number */}
                    <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="center">
                        <FormLabel mb={0} fontWeight="medium">Contact No. <Text as="span" color="red.500">*</Text></FormLabel>
                        <FormControl isInvalid={!!errors.contact_number}>
                            <Input 
                                {...register('contact_number', {
                                    required: 'Contact number is required',
                                    validate: (value) => {
                                        // Pattern 1: Starts with 0 and followed by exactly 10 digits (Total 11)
                                        const startsWithZero = /^0\d{10}$/.test(value);
                                        // Pattern 2: Starts with +63 and followed by exactly 10 digits (Total 12 characters)
                                        const startsWithPH = /^\+63\d{10}$/.test(value);
                                        
                                        return startsWithZero || startsWithPH || 'Must be 11 digits (starting with 0) or 12 characters (starting with +63)';
                                    }
                                })} 
                                placeholder="0XXXXXXXXXX or +63XXXXXXXXXX"
                                onInput={(e) => {
                                    // Keep only numbers and the plus sign
                                    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '');
                                }}
                            />
                            <FormErrorMessage>
                                {errors.contact_number?.message}
                            </FormErrorMessage>
                            <FormHelperText fontSize="xs">
                                Enter an 11-digit number starting with 0, or 12 characters starting with +63.
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    {/* Assign Trucks */}
                    <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
                        <FormLabel pt={2} fontWeight="medium">Assign Trucks</FormLabel>
                        <FormControl>
                            <VStack align="stretch" spacing={2}>
                                <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="gray.50">
                                    {selectedPlates.map((plate) => (
                                        <WrapItem key={plate}>
                                            <Tag size="md" variant="solid" colorScheme="blue" borderRadius="full">
                                                <TagLabel>{plate}</TagLabel>
                                                <TagCloseButton onClick={() => setValue('assigned_truck_plate_numbers', selectedPlates.filter(p => p !== plate))} />
                                            </Tag>
                                        </WrapItem>
                                    ))}
                                </Wrap>
                                <Box position="relative" ref={truckRef}>
                                    <InputGroup size="sm">
                                        <Input placeholder="Search truck plate..." value={truckSearch} onChange={(e) => {setTruckSearch(e.target.value); setShowTruckResults(true)}} />
                                        <InputRightElement>{loadingData && <Spinner size="xs" />}</InputRightElement>
                                    </InputGroup>
                                    {showTruckResults && truckSearch && (
                                        <List position="absolute" top="100%" left={0} right={0} bg={listBg} boxShadow="lg" borderRadius="md" zIndex={11} maxH="150px" overflowY="auto" border="1px solid" borderColor={borderColor} mt={1}>
                                            {filteredTrucks.map(t => (
                                                <ListItem key={t.id} px={3} py={2} _hover={{ bg: 'blue.50', cursor: 'pointer' }} onClick={() => { setValue('assigned_truck_plate_numbers', [...selectedPlates, t.plate_number]); setTruckSearch(''); setShowTruckResults(false); }}>
                                                    {t.plate_number}
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}
                                </Box>
                            </VStack>
                        </FormControl>
                    </Grid>

                    {/* Updated: Assign Helper (Single) */}
                    {/* <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
                        <FormLabel pt={2} fontWeight="medium">Assign Helper</FormLabel>
                        <FormControl>
                            <VStack align="stretch" spacing={2}>
                                <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="gray.50">
                                    {selectedHelperId > 0 && (
                                        <WrapItem>
                                            <Tag size="md" variant="solid" colorScheme="green" borderRadius="full">
                                                <TagLabel>{getHelperName(selectedHelperId)}</TagLabel>
                                                <TagCloseButton onClick={handleRemoveHelper} />
                                            </Tag>
                                        </WrapItem>
                                    )}
                                    {!selectedHelperId && <Text fontSize="xs" color="gray.400" p={1}>No helper assigned</Text>}
                                </Wrap>

                                <Box position="relative" ref={helperRef}>
                                    <InputGroup size="sm">
                                        <Input 
                                            placeholder="Search helper name..." 
                                            value={helperSearch}
                                            onChange={(e) => { setHelperSearch(e.target.value); setShowHelperResults(true); }}
                                            onFocus={() => setShowHelperResults(true)}
                                        />
                                        <InputRightElement>{loadingData && <Spinner size="xs" />}</InputRightElement>
                                    </InputGroup>

                                    {showHelperResults && helperSearch && (
                                        <List position="absolute" top="100%" left={0} right={0} bg={listBg} boxShadow="lg" borderRadius="md" zIndex={10} maxH="150px" overflowY="auto" border="1px solid" borderColor={borderColor} mt={1}>
                                            {filteredHelpers.map((helper) => (
                                                <ListItem 
                                                    key={helper.id} px={3} py={2} 
                                                    _hover={{ bg: 'green.50', color: 'green.700', cursor: 'pointer' }}
                                                    onClick={() => handleAddHelper(helper.id)}
                                                >
                                                    <Text fontSize="sm">{helper.first_name} {helper.last_name}</Text>
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}
                                </Box>
                            </VStack>
                        </FormControl>
                    </Grid> */}
                    <Grid templateColumns={{ base: '1fr', md: '3fr 9fr' }} gap={4} alignItems="start">
                        <FormLabel pt={2} fontWeight="medium">Assign Helper</FormLabel>
                        <FormControl>
                            <VStack align="stretch" spacing={2}>
                                <Wrap spacing={2} minH="40px" p={2} border="1px solid" borderColor={borderColor} borderRadius="md" bg="gray.50">
                                    {/* 5. Check for null explicitly */}
                                    {selectedHelperId !== null && selectedHelperId > 0 ? (
                                        <WrapItem>
                                            <Tag size="md" variant="solid" colorScheme="green" borderRadius="full">
                                                <TagLabel>{getHelperName(selectedHelperId)}</TagLabel>
                                                <TagCloseButton onClick={handleRemoveHelper} />
                                            </Tag>
                                        </WrapItem>
                                    ) : (
                                        <Text fontSize="xs" color="gray.400" p={1}>No helper assigned</Text>
                                    )}
                                </Wrap>

                                <Box position="relative" ref={helperRef}>
                                    <InputGroup size="sm">
                                        <Input 
                                            placeholder="Search helper name..." 
                                            value={helperSearch}
                                            onChange={(e) => { setHelperSearch(e.target.value); setShowHelperResults(true); }}
                                            onFocus={() => setShowHelperResults(true)}
                                        />
                                        <InputRightElement>{loadingData && <Spinner size="xs" />}</InputRightElement>
                                    </InputGroup>

                                    {showHelperResults && helperSearch && (
                                        <List position="absolute" top="100%" left={0} right={0} bg={listBg} boxShadow="lg" borderRadius="md" zIndex={10} maxH="150px" overflowY="auto" border="1px solid" borderColor={borderColor} mt={1}>
                                            {filteredHelpers.map((helper) => (
                                                <ListItem 
                                                    key={helper.id} px={3} py={2} 
                                                    _hover={{ bg: 'green.50', color: 'green.700', cursor: 'pointer' }}
                                                    onClick={() => handleAddHelper(helper.id)}
                                                >
                                                    <Text fontSize="sm">{helper.first_name} {helper.last_name}</Text>
                                                </ListItem>
                                            ))}
                                        </List>
                                    )}
                                </Box>
                            </VStack>
                        </FormControl>
                    </Grid>
                </VStack>

                <HStack spacing={4} justify="flex-end" pt={4}>
                    <Button variant="outline" onClick={onCancel} isDisabled={isSubmitting}>Cancel</Button>
                    <Button type="submit" colorScheme="blue" isLoading={isSubmitting} px={8}>
                        {isEditMode ? 'Save' : 'Create Driver'}
                    </Button>
                </HStack>
            </VStack>
        </Box>
    );
}
